"use client"

import { createContext, useState, useEffect } from "react";
import teslaImg from "../Image/1.png";
import bmwImg from "../Image/2.png";
import mercedesImg from "../Image/3.png";
import audiImg from "../Image/4.png";
import rangeRoverImg from "../Image/5.png";
import porscheImg from "../Image/6.png";
import lamborghiniImg from "../Image/7.png";
import ferrariImg from "../Image/8.png";

export const DataContext = createContext({
  cars: [],
  loading: true,
  selectedCar: null,
  setSelectedCar: () => {},
  getCarById: () => {},
});

export const DataProvider = ({ children }) => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCar, setSelectedCar] = useState(null);

  useEffect(() => {
    const loadCars = async () => {
      try {
        const carsData = [
          {
            id: 1,
            name: "Tesla Model S",
            price: 30000,
            image: teslaImg,
            transmission: "Automatic",
            seats: 5,
            fuelType: "Electric",
            mileage: "Unlimited",
            details: {
              description:
                "Experience luxury in the Tesla Model S. With its automatic transmission and seating for 5, every journey is exceptional. This car combines performance and comfort for an unforgettable drive.",
            },
          },
          {
            id: 2,
            name: "BMW M5",
            price: 24000,
            image: bmwImg,
            transmission: "Automatic",
            seats: 5,
            fuelType: "Petrol",
            mileage: "22 MPG",
            details: {
              description:
                "The BMW M5 delivers thrilling performance with luxurious comfort. A sports sedan engineered for driving pleasure.",
            },
          },
          {
            id: 3,
            name: "Mercedes G-Class",
            price: 35000,
            image: mercedesImg,
            transmission: "Automatic",
            seats: 5,
            fuelType: "Diesel",
            mileage: "18 MPG",
            details: {
              description:
                "The Mercedes G-Class is a luxury SUV with iconic design, unmatched off-road capability, and modern comfort.",
            },
          },
          {
            id: 4,
            name: "Audi R8",
            price: 50000,
            image: audiImg,
            transmission: "Automatic",
            seats: 2,
            fuelType: "Petrol",
            mileage: "15 MPG",
            details: {
              description:
                "The Audi R8 combines breathtaking performance and design, delivering a true supercar experience.",
            },
          },
          {
            id: 5,
            name: "Range Rover Velar",
            price: 40000,
            image: rangeRoverImg,
            transmission: "Automatic",
            seats: 5,
            fuelType: "Diesel",
            mileage: "28 MPG",
            details: {
              description:
                "The Range Rover Velar offers premium SUV comfort, advanced technology, and strong performance.",
            },
          },
          {
            id: 6,
            name: "Porsche 911",
            price: 42500,
            image: porscheImg,
            transmission: "Automatic",
            seats: 4,
            fuelType: "Petrol",
            mileage: "23 MPG",
            details: {
              description:
                "The Porsche 911 is a timeless sports car that blends classic design with cutting-edge engineering.",
            },
          },
          {
            id: 7,
            name: "Lamborghini Huracán",
            price: 100000,
            image: lamborghiniImg,
            transmission: "Automatic",
            seats: 2,
            fuelType: "Petrol",
            mileage: "13 MPG",
            details: {
              description:
                "The Lamborghini Huracán is a supercar masterpiece, designed for extreme performance and stunning looks.",
            },
          },
          {
            id: 8,
            name: "Ferrari F8 Tributo",
            price: 150000,
            image: ferrariImg,
            transmission: "Automatic",
            seats: 2,
            fuelType: "Petrol",
            mileage: "15 MPG",
            details: {
              description:
                "The Ferrari F8 Tributo represents the pinnacle of Italian performance, combining speed, precision, and beauty.",
            },
          },
        ];

        setCars(carsData);
        setLoading(false);
      } catch (error) {
        console.error("Error loading cars:", error);
        setLoading(false);
      }
    };

    loadCars();
  }, []);

  const getCarById = (id) => {
    return cars.find((car) => car.id === parseInt(id));
  };

  return (
    <DataContext.Provider
      value={{ cars, loading, selectedCar, setSelectedCar, getCarById }}
    >
      {children}
    </DataContext.Provider>
  );
};
